module.exports = __webpack_public_path__ + "static/media/sinceImg.2d3cdb94.svg";